import {
  ListSemantic_getInstance1hx6c2zatma42 as ListSemantic_getInstance,
  DialogSemantic_getInstance3cqn6ufjbbrs2 as DialogSemantic_getInstance,
  FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance,
  SubtextSemantic_getInstance3oi0npjp97gok as SubtextSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { LightSection_getInstance1p9fz392synu9 as LightSection_getInstance } from '../theming/sections.mjs';
import { get_compact3lsezez8nz8b6 as get_compact } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  get_expanding10cuv3ua9vajx as get_expanding,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { Checkbox2he0oy51inwu6 as Checkbox } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Checkbox.commonHtml.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  body3i5t0n7zprpqb as body,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  title1nssp3ryhwuqj as title,
  bodyBold2czwdzwknab0k as bodyBold,
  title1ahgushtajx2d as title_0,
} from '../theming/Titles.mjs';
import { weightt34o7llf2uyq as weight } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77,
  SpecViewgfdgv6h7w5ti as SpecView,
} from '../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { Align_End_getInstance1wccjuzcldlk8 as Align_End_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../sdk/UserSession.mjs';
import {
  await1kke5zj2piplv as await_0,
  awaitqeg6zusi9ora as await_1,
} from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Specification3fgfbf7ihgj8v as Specification } from '../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import {
  get__id1jb1ank0whnwb as get__id,
  get_group3r0mzizyuszin as get_group,
} from '../../../../../crowpay-shared/com/crowpay/SpecificationFields.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { inside3oxyfk5qky4sm as inside } from '../../../../../lightning-server-shared/com/lightningkite/lightningdb/ConditionBuilder.mjs';
import { ModificationBuilderuhgnvnxpchbi as ModificationBuilder } from '../../../../../lightning-server-shared/com/lightningkite/lightningdb/ModificationBuilder.mjs';
import { MassModification2g7vooufrvzd as MassModification } from '../../../../../lightning-server-shared/com/lightningkite/lightningdb/MassModification.mjs';
import { toSet2orjxp16sotqu as toSet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { get_dialogStackleaqvayyucjw as get_dialogStack } from '../components/nav/crowpay.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ReactiveMutableList2gg4x024enrbf as ReactiveMutableList } from '../../../../../reactive/com/lightningkite/reactive/core/ReactiveMutableList.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { DismissBackground1nezyx9ss0e1b as DismissBackground } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/DismissBackground.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../components/nav/AppDimensions.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
  get_scrolling27q1yr4ng0cx8 as get_scrolling,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../theming/AppColors.mjs';
import { colored3y8uibz1hk46 as colored } from '../theming/colorManagement.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import { TextArea6va0jt1dj0tc as TextArea } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextArea.commonHtml.mjs';
import { errorTextv58wi1t0me7u as errorText } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { label287uhiq3m9m4z as label2 } from '../components/label2.mjs';
import {
  get_secondaryButtondor94xxt3ws3 as get_secondaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  specCenteredText33v0vmsdeuehr as specCenteredText_0,
} from '../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function checkboxSelectSpecification(_this__u8e3s4, selectedItems, items) {
  var tmp = _this__u8e3s4.hbb(ListSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  var _iterator__ex2g4s = items.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var select = selectedItems.aan(item);
    var tmp_0 = view.ibb(view.hbb(LightSection_getInstance()), get_compact(view));
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_0 = view.cbb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.ebb(p_0, view_0);
    view_0.xbm(false);
    var tmp_1 = get_centered(view_0);
    // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (Checkbox())(view_0.pc());
    var tmp0_elvis_lhs_1 = view_0.cbb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
    view_0.ebb(p_1, view_1);
    view_1.xah(view_1.cbk_1, select);
    view_0.fbb(p_1, view_1);
    view_0.jbb(tmp_1, view_1);
    view_0.jbb(view_0.ibb(get_expanding(view_0), get_centered(view_0)), body(view_0, item.x83_1));
    var tmp_2 = item.z83_1;
    if (!((tmp_2 == null ? null : new (MonetaryValue())(tmp_2)) == null)) {
      var tmp_3 = view_0.ibb(weight(view_0, 0.8), get_centered(view_0));
      // Inline function 'com.crowpay.views.theming.body' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_2 = new (TextView())(view_0.pc());
      var tmp0_elvis_lhs_2 = view_0.cbb_1;
      var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
      view_0.ebb(p_2, view_2);
      view_2.jba(view_2.ob6_1.ybe(BodySemantic_getInstance()));
      var tmp0_elvis_lhs_3 = item.z83_1;
      var tmp_4;
      var tmp_5 = tmp0_elvis_lhs_3;
      if ((tmp_5 == null ? null : new (MonetaryValue())(tmp_5)) == null) {
        tmp_4 = Companion_instance.o62(0);
      } else {
        tmp_4 = tmp0_elvis_lhs_3;
      }
      // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
      var value = MonetaryValue__toString_impl_xslc77(tmp_4);
      var tmp_6 = view_2.tb5_1;
      var tmp_7;
      // Inline function 'kotlin.text.isEmpty' call
      if (charSequenceLength(value) === 0) {
        tmp_7 = '\xA0';
      } else {
        tmp_7 = value;
      }
      tmp_6.fbu(tmp_7);
      view_2.bbs(Align_End_getInstance());
      view_0.fbb(p_2, view_2);
      view_0.jbb(tmp_3, view_2);
    }
    view.fbb(p_0, view_0);
    view.jbb(tmp_0, view_0);
  }
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
function *_generator_invoke__zhh2q8($this, $completion) {
  if (isBlank($this.yik_1.vik_1.f2()))
    return Unit_instance;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  var tmp_0 = $this.yik_1.vik_1.f2();
  var tmp_1 = $this.yik_1.wik_1.f2();
  var tmp0_safe_receiver = $this.yik_1.qik_1;
  var view = new (SpecView())(VOID, tmp_0, tmp_1, $this.yik_1.rik_1, tmp0_safe_receiver == null ? null : tmp0_safe_receiver.o82_1);
  // Inline function 'com.lightningkite.lightningdb.condition' call
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_2 = serializerOrContextual(createKType(getKClass(Specification()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
  // Inline function 'kotlin.let' call
  var spec = new (DataClassPathSelf())(tmp$ret$1);
  var tmp_3 = get__id(spec);
  // Inline function 'kotlin.collections.map' call
  var this_1 = $this.yik_1.uik_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s = this_1.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp$ret$3 = item.u83_1;
    destination.v(tmp$ret$3);
  }
  var tmp_4 = inside(tmp_3, destination);
  // Inline function 'com.lightningkite.lightningdb.modification' call
  // Inline function 'kotlin.apply' call
  var this_2 = new (ModificationBuilder())();
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_5 = serializerOrContextual(createKType(getKClass(Specification()), arrayOf([]), false));
  var tmp$ret$9 = isInterface(tmp_5, KSerializer()) ? tmp_5 : THROW_CCE();
  var it = new (DataClassPathSelf())(tmp$ret$9);
  this_2.e44(get_group(it), view);
  var tmp$ret$14 = this_2.o1r();
  var tmp_6 = session.ofv_1.dek(new (MassModification())(tmp_4, tmp$ret$14), $completion);
  if (tmp_6 === get_COROUTINE_SUSPENDED())
    tmp_6 = yield tmp_6;
  var tmp1_safe_receiver = $this.yik_1.sik_1;
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.collections.map' call
    var this_3 = $this.yik_1.uik_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList().u(collectionSizeOrDefault(this_3, 10));
    var _iterator__ex2g4s_0 = this_3.m1();
    while (_iterator__ex2g4s_0.n1()) {
      var item_0 = _iterator__ex2g4s_0.o1();
      var tmp$ret$15 = item_0.u83_1;
      destination_0.v(tmp$ret$15);
    }
    var tmp_7 = tmp1_safe_receiver(view, toSet(destination_0), $completion);
    if (tmp_7 === get_COROUTINE_SUSPENDED())
      tmp_7 = yield tmp_7;
  }
  get_dialogStack().ngd();
  return Unit_instance;
}
var SpecViewDialog$render$slambdaClass;
function SpecViewDialog$render$slambda() {
  if (SpecViewDialog$render$slambdaClass === VOID) {
    class $ {
      sao($completion) {
        get_dialogStack().ngd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    SpecViewDialog$render$slambdaClass = $;
  }
  return SpecViewDialog$render$slambdaClass;
}
function SpecViewDialog$render$slambda_0() {
  var i = new (SpecViewDialog$render$slambda())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var SpecViewDialog$render$slambdaClass_0;
function SpecViewDialog$render$slambda_1() {
  if (SpecViewDialog$render$slambdaClass_0 === VOID) {
    class $ {
      sao($completion) {
        get_dialogStack().ngd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    SpecViewDialog$render$slambdaClass_0 = $;
  }
  return SpecViewDialog$render$slambdaClass_0;
}
function SpecViewDialog$render$slambda_2() {
  var i = new (SpecViewDialog$render$slambda_1())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.tb5_1.zb3_1.ib7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.tb5_1.zb3_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.ib7_1.disabled = value;
    return Unit_instance;
  };
}
var SpecViewDialog$render$slambdaClass_1;
function SpecViewDialog$render$slambda_3() {
  if (SpecViewDialog$render$slambdaClass_1 === VOID) {
    class $ {
      constructor(this$0) {
        this.yik_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    SpecViewDialog$render$slambdaClass_1 = $;
  }
  return SpecViewDialog$render$slambdaClass_1;
}
function SpecViewDialog$render$slambda_4(this$0) {
  var i = new (SpecViewDialog$render$slambda_3())(this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var SpecViewDialogClass;
function SpecViewDialog() {
  if (SpecViewDialogClass === VOID) {
    class $ {
      constructor(options, parent, isSet, withSelection) {
        parent = parent === VOID ? null : parent;
        withSelection = withSelection === VOID ? null : withSelection;
        this.qik_1 = parent;
        this.rik_1 = isSet;
        this.sik_1 = withSelection;
        var tmp = this;
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList().w();
        var _iterator__ex2g4s = options.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          var tmp_0;
          if (element.w83_1 == null) {
            tmp_0 = true;
          } else {
            var tmp0_safe_receiver = element.w83_1;
            var tmp_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.o82_1;
            var tmp1_safe_receiver = this.qik_1;
            tmp_0 = equals(tmp_1, tmp1_safe_receiver == null ? null : tmp1_safe_receiver.o82_1);
          }
          if (tmp_0) {
            destination.v(element);
          }
        }
        tmp.tik_1 = destination;
        this.uik_1 = ReactiveMutableList().tam();
        this.vik_1 = Signal().fak('');
        this.wik_1 = Signal().fak('');
        this.xik_1 = this.rik_1 ? 'Set' : 'View';
      }
      ud6(_this__u8e3s4) {
        // Inline function 'com.crowpay.views.components.dismissBackground2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (DismissBackground())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        view.tbo(SpecViewDialog$render$slambda_0());
        var tmp = view.ibb(get_centered(view), view.hbb(DialogSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Frame())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        view_0.eba(get_AppDimensions().wg1_1);
        view_0.zb8(get_AppDimensions().wg1_1);
        var tmp_0 = sizeConstraints(view_0, get_rem(40));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.ebb(p_1, view_1);
        view_1.xbm(true);
        view_1.zb8(get_AppDimensions().xg1_1);
        title(view_1, 'New Spec ' + this.xik_1);
        // Inline function 'com.crowpay.views.components.requiredField' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.cbb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.ebb(p_2, view_2);
        view_2.xbm(true);
        view_2.zb8(get_AppDimensions().ng2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (RowOrCol())(view_2.pc());
        var tmp0_elvis_lhs_3 = view_2.cbb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
        view_2.ebb(p_3, view_3);
        view_3.xbm(false);
        view_3.zb8(get_AppDimensions().pg2_1);
        view_3.jbb(get_centered(view_3), bodyBold(view_3, 'Title'));
        view_3.jbb(colored(view_3, AppColors_getInstance().hfz_1.xg9_1), bodyBold(view_3, '*'));
        view_2.fbb(p_3, view_3);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_1 = view_2.hbb(FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (TextInput())(view_2.pc());
        var tmp0_elvis_lhs_4 = view_2.cbb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_2 : tmp0_elvis_lhs_4;
        view_2.ebb(p_4, view_4);
        // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
        // Inline function 'com.lightningkite.kiteui.views.placeholder' call
        view_4.tb5_1.zb3_1.ib7_1.placeholder = 'Title';
        view_4.xah(view_4.gcn_1, this.vik_1);
        view_2.fbb(p_4, view_4);
        view_2.jbb(tmp_1, view_4);
        view_1.fbb(p_2, view_2);
        // Inline function 'com.crowpay.views.components.field2' call
        var label = 'Description';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_5 = view_1.cbb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_1 : tmp0_elvis_lhs_5;
        view_1.ebb(p_5, view_5);
        view_5.xbm(true);
        view_5.zb8(get_AppDimensions().ng2_1);
        bodyBold(view_5, label);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_2 = view_5.hbb(FieldSemantic_getInstance());
        var tmp_3 = sizeConstraints(view_5, VOID, VOID, VOID, VOID, VOID, VOID, get_rem(10));
        // Inline function 'com.lightningkite.kiteui.views.direct.textArea' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (TextArea())(view_5.pc());
        var tmp0_elvis_lhs_6 = view_5.cbb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
        view_5.ebb(p_6, view_6);
        view_6.xah(view_6.qcl_1, this.wik_1);
        view_5.fbb(p_6, view_6);
        var tmp$ret$20 = view_5.jbb(tmp_3, view_6);
        view_5.jbb(tmp_2, tmp$ret$20);
        view_5.jbb(view_5.hbb(SubtextSemantic_getInstance()), errorText(view_5));
        view_1.fbb(p_5, view_5);
        label2(view_1, 'Add Specifications', VOID, ($this$label2) => $this$label2.jbb($this$label2.ibb(sizeConstraints($this$label2, VOID, VOID, VOID, VOID, VOID, VOID, get_rem(17)), get_scrolling($this$label2)), checkboxSelectSpecification($this$label2, this.uik_1, this.tik_1)));
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_7 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_7 = view_1.cbb_1;
        var p_7 = tmp0_elvis_lhs_7 == null ? view_1 : tmp0_elvis_lhs_7;
        view_1.ebb(p_7, view_7);
        view_7.xbm(false);
        var tmp_4 = get_secondaryButton(view_7);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_8 = new (Button())(view_7.pc());
        var tmp0_elvis_lhs_8 = view_7.cbb_1;
        var p_8 = tmp0_elvis_lhs_8 == null ? view_7 : tmp0_elvis_lhs_8;
        view_7.ebb(p_8, view_8);
        specCenteredText(view_8, 'Discard');
        onClick(view_8, 'Discard Spec View', VOID, SpecViewDialog$render$slambda_2());
        view_7.fbb(p_8, view_8);
        view_7.jbb(tmp_4, view_8);
        var tmp_5 = get_primaryButton(view_7);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_9 = new (Button())(view_7.pc());
        var tmp0_elvis_lhs_9 = view_7.cbb_1;
        var p_9 = tmp0_elvis_lhs_9 == null ? view_7 : tmp0_elvis_lhs_9;
        view_7.ebb(p_9, view_9);
        var tmp_6 = KMutableProperty0();
        var tmp_7 = Button$_get_enabled_$ref_61t7nx(view_9);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_0 = getPropertyCallableRef('enabled', 0, tmp_6, tmp_7, Button$_set_enabled_$ref_o8kynz(view_9));
        reactiveScope(view_9, ($this$reactiveScope) => {
          var tmp;
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!$this$reactiveScope.baj(this.uik_1).i1()) {
            // Inline function 'kotlin.text.isNotBlank' call
            var this_1 = $this$reactiveScope.baj(this.vik_1);
            tmp = !isBlank(this_1);
          } else {
            tmp = false;
          }
          var tmp$ret$31 = tmp;
          this_0.set(tmp$ret$31);
          return Unit_instance;
        });
        specCenteredText_0(view_9, ($this$specCenteredText) => {
          // Inline function 'kotlin.text.ifBlank' call
          var this_0 = $this$specCenteredText.baj(this.vik_1);
          var tmp;
          if (isBlank(this_0)) {
            tmp = 'Spec ' + this.xik_1;
          } else {
            tmp = this_0;
          }
          return 'Create ' + tmp;
        });
        var tmp_8 = 'Create Spec ' + this.xik_1;
        onClick(view_9, tmp_8, VOID, SpecViewDialog$render$slambda_4(this));
        view_7.fbb(p_9, view_9);
        view_7.jbb(tmp_5, view_9);
        view_1.fbb(p_7, view_7);
        view_0.fbb(p_1, view_1);
        view_0.jbb(tmp_0, view_1);
        view.fbb(p_0, view_0);
        view.jbb(tmp, view_0);
        _this__u8e3s4.fbb(p, view);
        return view;
      }
    }
    protoOf($).ucv = get_title;
    initMetadataForClass($, 'SpecViewDialog', VOID, VOID, [Page()]);
    SpecViewDialogClass = $;
  }
  return SpecViewDialogClass;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  if (isBlank($this.hil_1.dil_1.f2()))
    return Unit_instance;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  var tmp_0 = $this.hil_1.dil_1.f2();
  // Inline function 'kotlin.takeUnless' call
  var this_1 = $this.hil_1.eil_1.f2();
  var tmp_1;
  if (!isBlank(this_1)) {
    tmp_1 = this_1;
  } else {
    tmp_1 = null;
  }
  var tmp$ret$2 = tmp_1;
  var view = $this.hil_1.zik_1.u82(VOID, tmp_0, tmp$ret$2, $this.hil_1.fil_1.f2());
  // Inline function 'com.lightningkite.lightningdb.condition' call
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_2 = serializerOrContextual(createKType(getKClass(Specification()), arrayOf([]), false));
  var tmp$ret$3 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
  // Inline function 'kotlin.let' call
  var spec = new (DataClassPathSelf())(tmp$ret$3);
  var tmp_3 = get__id(spec);
  // Inline function 'kotlin.collections.map' call
  var this_2 = $this.hil_1.cil_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_2, 10));
  var _iterator__ex2g4s = this_2.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp$ret$5 = item.u83_1;
    destination.v(tmp$ret$5);
  }
  var tmp_4 = inside(tmp_3, destination);
  // Inline function 'com.lightningkite.lightningdb.modification' call
  // Inline function 'kotlin.apply' call
  var this_3 = new (ModificationBuilder())();
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_5 = serializerOrContextual(createKType(getKClass(Specification()), arrayOf([]), false));
  var tmp$ret$11 = isInterface(tmp_5, KSerializer()) ? tmp_5 : THROW_CCE();
  var it = new (DataClassPathSelf())(tmp$ret$11);
  this_3.e44(get_group(it), view);
  var tmp$ret$16 = this_3.o1r();
  var tmp_6 = session.ofv_1.dek(new (MassModification())(tmp_4, tmp$ret$16), $completion);
  if (tmp_6 === get_COROUTINE_SUSPENDED())
    tmp_6 = yield tmp_6;
  var tmp0_safe_receiver = $this.hil_1.ail_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_4 = $this.hil_1.dil_1;
    var tmp_7 = await_1(this_4, $completion);
    if (tmp_7 === get_COROUTINE_SUSPENDED())
      tmp_7 = yield tmp_7;
    var tmp_8 = tmp_7;
    // Inline function 'kotlin.collections.map' call
    var this_5 = $this.hil_1.cil_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList().u(collectionSizeOrDefault(this_5, 10));
    var _iterator__ex2g4s_0 = this_5.m1();
    while (_iterator__ex2g4s_0.n1()) {
      var item_0 = _iterator__ex2g4s_0.o1();
      var tmp$ret$18 = item_0.u83_1;
      destination_0.v(tmp$ret$18);
    }
    var tmp_9 = tmp0_safe_receiver(tmp_8, view.r82_1, destination_0, $completion);
    if (tmp_9 === get_COROUTINE_SUSPENDED())
      tmp_9 = yield tmp_9;
  }
  get_dialogStack().ngd();
  return Unit_instance;
}
var EditSpecViewDialog$render$slambdaClass;
function EditSpecViewDialog$render$slambda() {
  if (EditSpecViewDialog$render$slambdaClass === VOID) {
    class $ {
      sao($completion) {
        get_dialogStack().ngd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    EditSpecViewDialog$render$slambdaClass = $;
  }
  return EditSpecViewDialog$render$slambdaClass;
}
function EditSpecViewDialog$render$slambda_0() {
  var i = new (EditSpecViewDialog$render$slambda())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
var EditSpecViewDialog$render$slambdaClass_0;
function EditSpecViewDialog$render$slambda_1() {
  if (EditSpecViewDialog$render$slambdaClass_0 === VOID) {
    class $ {
      sao($completion) {
        get_dialogStack().ngd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    EditSpecViewDialog$render$slambdaClass_0 = $;
  }
  return EditSpecViewDialog$render$slambdaClass_0;
}
function EditSpecViewDialog$render$slambda_2() {
  var i = new (EditSpecViewDialog$render$slambda_1())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.tb5_1.zb3_1.ib7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.tb5_1.zb3_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.ib7_1.disabled = value;
    return Unit_instance;
  };
}
var EditSpecViewDialog$render$slambdaClass_1;
function EditSpecViewDialog$render$slambda_3() {
  if (EditSpecViewDialog$render$slambdaClass_1 === VOID) {
    class $ {
      constructor(this$0) {
        this.hil_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    EditSpecViewDialog$render$slambdaClass_1 = $;
  }
  return EditSpecViewDialog$render$slambdaClass_1;
}
function EditSpecViewDialog$render$slambda_4(this$0) {
  var i = new (EditSpecViewDialog$render$slambda_3())(this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var EditSpecViewDialogClass;
function EditSpecViewDialog() {
  if (EditSpecViewDialogClass === VOID) {
    class $ {
      constructor(options, view, withSelection) {
        withSelection = withSelection === VOID ? null : withSelection;
        this.zik_1 = view;
        this.ail_1 = withSelection;
        var tmp = this;
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList().w();
        var _iterator__ex2g4s = options.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          var tmp_0;
          var tmp_1;
          if (element.w83_1 == null) {
            tmp_1 = true;
          } else {
            var tmp0_safe_receiver = element.w83_1;
            tmp_1 = equals(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.o82_1, this.zik_1.o82_1);
          }
          if (tmp_1) {
            tmp_0 = true;
          } else {
            var tmp1_safe_receiver = element.w83_1;
            tmp_0 = equals(tmp1_safe_receiver == null ? null : tmp1_safe_receiver.o82_1, this.zik_1.s82_1);
          }
          if (tmp_0) {
            destination.v(element);
          }
        }
        tmp.bil_1 = destination;
        var tmp_2 = this;
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination_0 = ArrayList().w();
        var _iterator__ex2g4s_0 = options.m1();
        while (_iterator__ex2g4s_0.n1()) {
          var element_0 = _iterator__ex2g4s_0.o1();
          var tmp0_safe_receiver_0 = element_0.w83_1;
          if (equals(tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.o82_1, this.zik_1.o82_1)) {
            destination_0.v(element_0);
          }
        }
        tmp_2.cil_1 = ReactiveMutableList().uam(destination_0);
        this.dil_1 = Signal().fak(this.zik_1.d99());
        var tmp_3 = this;
        var tmp0_elvis_lhs = this.zik_1.q82_1;
        tmp_3.eil_1 = Signal().fak(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs);
        this.fil_1 = Signal().fak(this.zik_1.r82_1);
        var tmp_4 = this;
        tmp_4.gil_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj(this.fil_1) ? 'Set' : 'View');
      }
      ud6(_this__u8e3s4) {
        // Inline function 'com.crowpay.views.components.dismissBackground2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (DismissBackground())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        view.tbo(EditSpecViewDialog$render$slambda_0());
        var tmp = view.ibb(get_centered(view), view.hbb(DialogSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Frame())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        view_0.eba(get_AppDimensions().wg1_1);
        view_0.zb8(get_AppDimensions().wg1_1);
        var tmp_0 = sizeConstraints(view_0, get_rem(40));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.ebb(p_1, view_1);
        view_1.xbm(true);
        view_1.zb8(get_AppDimensions().xg1_1);
        title_0(view_1, ($this$title) => {
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl($this$title);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb($this$title));
          reactiveScope($this$title, ($this$reactiveScope) => {
            var tmp$ret$0 = 'Edit- Spec ' + $this$reactiveScope.baj(this.gil_1);
            this_0.set(tmp$ret$0);
            return Unit_instance;
          });
          return Unit_instance;
        });
        // Inline function 'com.crowpay.views.components.requiredField' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.cbb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.ebb(p_2, view_2);
        view_2.xbm(true);
        view_2.zb8(get_AppDimensions().ng2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (RowOrCol())(view_2.pc());
        var tmp0_elvis_lhs_3 = view_2.cbb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
        view_2.ebb(p_3, view_3);
        view_3.xbm(false);
        view_3.zb8(get_AppDimensions().pg2_1);
        view_3.jbb(get_centered(view_3), bodyBold(view_3, 'Title'));
        view_3.jbb(colored(view_3, AppColors_getInstance().hfz_1.xg9_1), bodyBold(view_3, '*'));
        view_2.fbb(p_3, view_3);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_1 = view_2.hbb(FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (TextInput())(view_2.pc());
        var tmp0_elvis_lhs_4 = view_2.cbb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_2 : tmp0_elvis_lhs_4;
        view_2.ebb(p_4, view_4);
        // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
        // Inline function 'com.lightningkite.kiteui.views.placeholder' call
        view_4.tb5_1.zb3_1.ib7_1.placeholder = 'Title';
        view_4.xah(view_4.gcn_1, this.dil_1);
        view_2.fbb(p_4, view_4);
        view_2.jbb(tmp_1, view_4);
        view_1.fbb(p_2, view_2);
        // Inline function 'com.crowpay.views.components.field2' call
        var label = 'Description';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_5 = view_1.cbb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_1 : tmp0_elvis_lhs_5;
        view_1.ebb(p_5, view_5);
        view_5.xbm(true);
        view_5.zb8(get_AppDimensions().ng2_1);
        bodyBold(view_5, label);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_2 = view_5.hbb(FieldSemantic_getInstance());
        var tmp_3 = sizeConstraints(view_5, VOID, VOID, VOID, VOID, VOID, VOID, get_rem(10));
        // Inline function 'com.lightningkite.kiteui.views.direct.textArea' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (TextArea())(view_5.pc());
        var tmp0_elvis_lhs_6 = view_5.cbb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
        view_5.ebb(p_6, view_6);
        view_6.xah(view_6.qcl_1, this.eil_1);
        view_5.fbb(p_6, view_6);
        var tmp$ret$22 = view_5.jbb(tmp_3, view_6);
        view_5.jbb(tmp_2, tmp$ret$22);
        view_5.jbb(view_5.hbb(SubtextSemantic_getInstance()), errorText(view_5));
        view_1.fbb(p_5, view_5);
        label2(view_1, 'Add Specifications', VOID, ($this$label2) => $this$label2.jbb($this$label2.ibb(sizeConstraints($this$label2, VOID, VOID, VOID, VOID, VOID, VOID, get_rem(17)), get_scrolling($this$label2)), checkboxSelectSpecification($this$label2, this.cil_1, this.bil_1)));
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_7 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_7 = view_1.cbb_1;
        var p_7 = tmp0_elvis_lhs_7 == null ? view_1 : tmp0_elvis_lhs_7;
        view_1.ebb(p_7, view_7);
        view_7.xbm(false);
        var tmp_4 = get_secondaryButton(view_7);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_8 = new (Button())(view_7.pc());
        var tmp0_elvis_lhs_8 = view_7.cbb_1;
        var p_8 = tmp0_elvis_lhs_8 == null ? view_7 : tmp0_elvis_lhs_8;
        view_7.ebb(p_8, view_8);
        specCenteredText(view_8, 'Discard');
        onClick(view_8, 'Discard Spec View', VOID, EditSpecViewDialog$render$slambda_2());
        view_7.fbb(p_8, view_8);
        view_7.jbb(tmp_4, view_8);
        var tmp_5 = get_primaryButton(view_7);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_9 = new (Button())(view_7.pc());
        var tmp0_elvis_lhs_9 = view_7.cbb_1;
        var p_9 = tmp0_elvis_lhs_9 == null ? view_7 : tmp0_elvis_lhs_9;
        view_7.ebb(p_9, view_9);
        var tmp_6 = KMutableProperty0();
        var tmp_7 = Button$_get_enabled_$ref_61t7nx_0(view_9);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_0 = getPropertyCallableRef('enabled', 0, tmp_6, tmp_7, Button$_set_enabled_$ref_o8kynz_0(view_9));
        reactiveScope(view_9, ($this$reactiveScope) => {
          var tmp;
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!$this$reactiveScope.baj(this.cil_1).i1()) {
            // Inline function 'kotlin.text.isNotBlank' call
            var this_1 = $this$reactiveScope.baj(this.dil_1);
            tmp = !isBlank(this_1);
          } else {
            tmp = false;
          }
          var tmp$ret$33 = tmp;
          this_0.set(tmp$ret$33);
          return Unit_instance;
        });
        specCenteredText_0(view_9, ($this$specCenteredText) => {
          // Inline function 'kotlin.text.ifBlank' call
          var this_0 = $this$specCenteredText.baj(this.dil_1);
          var tmp;
          if (isBlank(this_0)) {
            tmp = 'Spec ' + toString(this.gil_1);
          } else {
            tmp = this_0;
          }
          return 'Save ' + tmp;
        });
        var tmp_8 = 'Save Spec ' + toString(this.gil_1);
        onClick(view_9, tmp_8, VOID, EditSpecViewDialog$render$slambda_4(this));
        view_7.fbb(p_9, view_9);
        view_7.jbb(tmp_5, view_9);
        view_1.fbb(p_7, view_7);
        view_0.fbb(p_1, view_1);
        view_0.jbb(tmp_0, view_1);
        view.fbb(p_0, view_0);
        view.jbb(tmp, view_0);
        _this__u8e3s4.fbb(p, view);
        return view;
      }
    }
    protoOf($).ucv = get_title;
    initMetadataForClass($, 'EditSpecViewDialog', VOID, VOID, [Page()]);
    EditSpecViewDialogClass = $;
  }
  return EditSpecViewDialogClass;
}
//region block: exports
export {
  EditSpecViewDialog as EditSpecViewDialog335omt1pbpcw2,
  SpecViewDialog as SpecViewDialogyrrvx4h1xg27,
};
//endregion

//# sourceMappingURL=SpecViewDialog.mjs.map
